module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_3009.6ff3a345.png";